import SimpleParallax from "simple-parallax-js";

var images = document.querySelectorAll(".banner-img");
new SimpleParallax(images, {
	scale: 1.1,
});
